import _ from 'lodash';

import * as constants from './Alumni.constants';
import * as services from './Alumni.service';

const state = {
  alumniBless: {
    bulletScreenList: [],
  },

  idxBulletScreenList: 0,
};

const mutations = {
  [constants.SET_ALUMNI_BLESS_SUCCESS](state, alumniBless) {
    if (undefined !== alumniBless && null !== alumniBless) {
      state.alumniBless = {
        ...alumniBless,
        bulletScreenList: [
          ...alumniBless.bulletScreenList,
          ...state.alumniBless.bulletScreenList.slice(state.idxBulletScreenList),
          ...state.alumniBless.bulletScreenList.slice(0, state.idxBulletScreenList),
        ].slice(0, 1000),
      };
    }
  },

  [constants.SET_IDX_BULLET_SCREEN_LIST](state, idxBulletScreenList) {
    state.idxBulletScreenList = idxBulletScreenList;
  },

  [constants.SET_IS_REQUEST_STATUS](state, data) {
    state.isRequest = data;
  },
};

const actions = {
  async getAlumniRefresh({ commit }, payload) {
    //commit(constants.SET_IS_REQUEST_STATUS, true);
    const res = await services.getAlumniRefresh(payload);
    commit(constants.SET_ALUMNI_BLESS_SUCCESS, res.data.data);
    commit(constants.SET_IDX_BULLET_SCREEN_LIST, 0);
    //commit(constants.SET_IS_REQUEST_STATUS, false);
  },

  async makeAlumniBless({ commit }, payload) {
    //commit(constants.SET_IS_REQUEST_STATUS, true);
    const res = await services.makeAlumniBless(payload);
    commit(constants.SET_ALUMNI_BLESS_SUCCESS, res.data.data.refreshData);
    commit(constants.SET_IDX_BULLET_SCREEN_LIST, 0);
    //commit(constants.SET_IS_REQUEST_STATUS, false);
  },

  setIdxBulletScreenList({ commit, state, getters }) {
    const idxBulletScreenList = (state.idxBulletScreenList + 1) % getters.bulletScreenList.length;
    commit(constants.SET_IDX_BULLET_SCREEN_LIST, idxBulletScreenList);
  },
};

const getters = {
  alumniBless: (state) => state.alumniBless,

  blessRawList: (state, getters) =>
    getters.alumniBless.blessRawList ? getters.alumniBless.blessRawList : [],

  txtBlessRawList(state, getters) {
    return _.map(getters.blessRawList, (blessRaw) => blessRaw.blessContent);
  },

  countriesBlessList: (state, getters) =>
    getters.alumniBless.countriesBlessList ? getters.alumniBless.countriesBlessList : [],

  bulletScreenList: (state, getters) =>
    getters.alumniBless.bulletScreenList ? getters.alumniBless.bulletScreenList : [],

  currentBulletScreenList: (state, getters) => {
    let currentBulletScreenList = getters.bulletScreenList[state.idxBulletScreenList];
    return currentBulletScreenList ? currentBulletScreenList : null;
  },

  hasJoined: (state, getters) => getters.alumniBless.hasJoined,

  mainCourseStudent: (state, getters) => getters.alumniBless.mainCourseStudent,

  alumniStatus: (state, getters) => getters.alumniBless.alumniStatus,

  lastQueryTime: (state, getters) => getters.alumniBless.lastQueryTime,
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
